import { getContrastTextColor } from "../../utilities/helpers/getContrastTextColor";

export const ZONE_CHIP =
  "inline-flex items-center rounded border border-theme-border px-2 py-1 compact:px-1.5 compact:py-0.5 text-xs compact:text-[0.65rem] leading-none font-semibold whitespace-nowrap";

export const NEUTRAL_ZONE_CHIP = "bg-theme-surface text-theme-text";

export const zoneColourStyle = (colour: string): React.CSSProperties =>
  ({ backgroundColor: colour, color: getContrastTextColor(colour) });

export function ZoneChip({ name, colour }: { name: string; colour?: string }) {
  return (
    <span
      className={colour ? ZONE_CHIP : `${ZONE_CHIP} ${NEUTRAL_ZONE_CHIP}`}
      style={colour ? zoneColourStyle(colour) : undefined}
    >
      {name}
    </span>
  );
}
